export class Certificado {
    id: number;
    serial: string;
    emissor: string;
    nome: string;
    cpf: string;
    validade: string;
    emissao: string;
    email: string;
    certificadoBase64: string;
    tituloEleitor: string;
    valido: string;
    tipo: string;
    invalidoMsg: string;
    tipoCertificado: string;
    cn: string;
    status: string;
    urlRevogacaoGAR: string
}